import {
  HeroSection,
  ProductSection,
  CTASection,
  FooterSection,
  NavbarSection,
} from "./Components";
function App() {
  return (
    <div className='App'>
      <NavbarSection />
      <HeroSection />
      <ProductSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}

export default App;
